export default "__VITE_ASSET__BKiz5tCA__"